import { render } from "./PartnerPage.vue?vue&type=template&id=3ace7973&scoped=true"
import script from "./PartnerPage.vue?vue&type=script&lang=js"
export * from "./PartnerPage.vue?vue&type=script&lang=js"

import "./PartnerPage.vue?vue&type=style&index=0&id=3ace7973&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ace7973"]])

export default __exports__